<script setup lang="ts">
import { ref } from 'vue';
import { ChevronDown } from 'lucide-vue-next';
import type { TopMenuLinkView } from '@/nav/menuModel';
import NavSiteBrand from '@/components/navigation/NavSiteBrand.vue';
import type { SiteLogo } from '@/navTree';

defineProps<{
  siteName: string;
  siteSubtitle: string;
  siteLogos: SiteLogo[];
  rootUrl: string;
  topMenuLinks: TopMenuLinkView[];
  hasTopMenuChildren: (item: TopMenuLinkView) => boolean;
}>();

const rootRef = ref<HTMLElement | null>(null);

defineExpose({
  rootRef,
});
</script>

<template>
  <div
    ref="rootRef"
    class="side-nav__desktop-row-probe"
    aria-hidden="true"
  >
    <div class="side-nav__desktop-bar-inner side-nav__desktop-bar-inner--probe">
      <NavSiteBrand
        :root-url="rootUrl"
        :site-name="siteName"
        :site-subtitle="siteSubtitle"
        :site-logos="siteLogos"
        link-class="side-nav__desktop-brand--probe"
      />
      <nav class="side-nav__desktop-links" aria-hidden="true">
        <template v-for="item in topMenuLinks" :key="'probe-' + item.sectionKey">
          <div v-if="hasTopMenuChildren(item)" class="side-nav__desktop-item">
            <span class="side-nav__desktop-nav-trigger side-nav__desktop-nav-trigger--probe">
              <span class="side-nav__desktop-nav-label">{{ item.label }}</span>
              <ChevronDown class="side-nav__desktop-chevron" aria-hidden="true" />
            </span>
          </div>
          <span v-else class="side-nav__desktop-single-link side-nav__desktop-single-link--probe">
            <span class="side-nav__desktop-nav-label">{{ item.label }}</span>
          </span>
        </template>
      </nav>
      <div class="side-nav__desktop-end side-nav__desktop-end--probe">
        <div class="side-nav__desktop-tools">
          <div class="side-nav__search-probe" aria-hidden="true" />
          <div class="side-nav__lang-wrap side-nav__lang-wrap--desktop">
            <div class="side-nav__lang-probe-placeholder" />
          </div>
          <div class="side-nav__login-probe" aria-hidden="true" />
        </div>
      </div>
    </div>
  </div>
</template>
